import React from 'react';

const MediaPreviewModal = ({ previewImage, setPreviewImage, previewVideo, setPreviewVideo }) => {
  return (
    <>
      {previewImage && (
        <div className="wc-media-modal" onClick={() => setPreviewImage(null)}>
          <button className="wc-media-close" onClick={() => setPreviewImage(null)}>✖</button>
          <img src={previewImage} />
        </div>
      )}

      {previewVideo && (
        <div className="wc-media-modal" onClick={() => setPreviewVideo(null)}>
          <button className="wc-media-close" onClick={() => setPreviewVideo(null)}>✖</button>
          <video controls autoPlay>
            <source src={previewVideo} />
          </video>
        </div>
      )}
    </>
  );
};

export default MediaPreviewModal;